import { Controller } from "@hotwired/stimulus"

// Fila clicable: un click en la fila navega a `urlValue` (vista detalle, ej.
// el show del equipo). Los clicks sobre un <a>/<button> anidado —o marcados
// con `data-v2--row-link-ignore`— se dejan pasar: gana la navegación nativa
// del propio elemento (link al router, link del equipo, acciones). Sin BS-JS.
//
// Con `frameValue` la visita queda DENTRO de ese turbo-frame (el detalle abre
// en modal sobre la página actual); sin él es la navegación completa de siempre.
export default class extends Controller {
  static values = { url: String, frame: String }

  click(event) {
    if (!this.urlValue) return
    if (event.target.closest("a, button, [data-v2--row-link-ignore]")) return

    if (this.frameValue) {
      Turbo.visit(this.urlValue, { frame: this.frameValue })
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
